import React from 'react';
import { useAuth } from '../contexts/AuthContext';

interface RemainingPhotosIndicatorProps {
  visible: boolean;
}

export const RemainingPhotosIndicator: React.FC<RemainingPhotosIndicatorProps> = ({ visible }) => {
  const { photoLimitInfo } = useAuth();

  // Don't show if not visible, no limit info, or unlimited (admin)
  if (!visible || !photoLimitInfo || photoLimitInfo.limit === null) {
    return null;
  }

  const { remaining, limit } = photoLimitInfo;
  const isLow = remaining !== null && remaining <= 5;
  const isVeryLow = remaining !== null && remaining <= 2;

  return (
    <div className="absolute top-4 left-1/2 transform -translate-x-1/2 z-30">
      <div
        className={`
          px-4 py-2 rounded-full backdrop-blur-sm
          ${isVeryLow ? 'bg-red-500/80 text-white' : isLow ? 'bg-yellow-500/80 text-black' : 'bg-black/50 text-white'}
          font-medium text-sm transition-colors duration-300
        `}
      >
        {remaining} / {limit} photos left
      </div>
    </div>
  );
};
